import { render, staticRenderFns } from "./tasks-info.vue?vue&type=template&id=70f47826&scoped=true"
import script from "./tasks-info.vue?vue&type=script&lang=js"
export * from "./tasks-info.vue?vue&type=script&lang=js"
import style0 from "./tasks-info.vue?vue&type=style&index=0&id=70f47826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f47826",
  null
  
)

export default component.exports